//============================
//# mlsysisync_partner DTO
//# Partner köztes tábla — kiegészítve a felületi állapot-mezőkkel és számolt mezőkkel
//============================
import IfaceSyncPartner, { IfaceSyncPartnerDefaultProps } from "./IfaceSyncPartner";

export default interface IfaceSyncPartnerDTO extends IfaceSyncPartner {
    /** Kiválasztva (felületi állapot, tömeges műveletekhez — független a többi flag-től) */
    selected: boolean;
    /** Szerkesztés alatt (felületi állapot) */
    inEdit: boolean;
    /** Sor lenyitható részletek master toggle (felületi állapot) */
    showDetails: boolean;
    /** Szinkron előzmények megjelenítése (showDetails-szel együtt) */
    showHistory: boolean;
    /** Betöltött előzmény rekordok — null/undefined: töltés alatt, []: nincs adat (frontend only) */
    history: IfaceSyncPartnerDTO[] | null;
    /** Utolsó szinkronizálás pontos ideje (updDate dátum része + updTime időpont része, backend kombinálja) */
    updDateTime: Date;
    /** Utoljára módosító munkatárs neve (msgenuser join) */
    updUserName: string;
    /** Szinkron státusz megnevezése (sssysisyncstatus join) */
    syncStatusName: string;
}

export const IfaceSyncPartnerDTODefaultProps: IfaceSyncPartnerDTO = {
    ...IfaceSyncPartnerDefaultProps,
    selected: false,
    inEdit: false,
    showDetails: false,
    showHistory: false,
    history: null,
    updDateTime: new Date(),
    updUserName: "",
    syncStatusName: "",
}
